export const buildDismissApiConfig = ({ cardId, days }) => ({
    url: `/api/cards/${cardId}/dismiss/`,
    method: 'PATCH',
    data: {
        days,
    },
});
